var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460.8 460.8V310.784C460.8 237.056 444.928 180.736 358.912 180.736C317.44 180.736 289.792 203.264 278.528 224.768H277.504V187.392H196.096V460.8H281.088V325.12C281.088 289.28 287.744 254.976 331.776 254.976C375.296 254.976 375.808 295.424 375.808 327.168V460.288H460.8V460.8Z",
    fill: "#B88831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.856 187.392H142.848V460.8H57.856V187.392Z",
    fill: "#B88831"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.352 51.2C73.216 51.2 51.2 73.216 51.2 100.352C51.2 127.488 73.216 150.016 100.352 150.016C127.488 150.016 149.504 127.488 149.504 100.352C149.504 73.216 127.488 51.2 100.352 51.2Z",
    fill: "#B88831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinContact);
export default __webpack_public_path__ + "static/media/linkedin-contact.dd6d9663ad5cb1d414200aded4e687b5.svg";
export { ForwardRef as ReactComponent };